/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".shareicon[_ngcontent-%COMP%]{height:18px}.sharew[_ngcontent-%COMP%]{margin-top:4px;font-size:small}li[_ngcontent-%COMP%]{display:inline-block;margin:0 5px 5px 0;padding:0;width:55px;float:none!important;text-align:center}a[_ngcontent-%COMP%]{display:inline-block}"];
export { styles as styles };
